import { useState } from "react";
import "./PreviousMatchReponseBlock.css";
import axios from "axios";
import { Link } from "react-router-dom";
import { getVip } from "../../handlers/dictionaryHandler.js";

const PreviousMatchResponseBlock = ({
  otherName,
  weeklyMatchesUsageLeft,
  matchId,
  otherId,
  onMatchRenewal,
  isOtherActive,
}) => {
  const [answerText, setAnswerText] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showSubscribeLink, setShowSubscribeLink] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const isAlreadySaidYes = true;

  const alertUser = (message) => {
    setAlertMessage(message);
    setShowSubscribeLink(false);
    setShowAlert(true);
  };

  const renewMatch = async () => {
    if (isOtherActive === false) {
      alertUser("המשתמש בהשהיית שימוש");
      return;
    }

    if (localStorage.getItem("VIP") !== "1") {
      setAlertMessage(
        "רוצה לתת להתאמה הזו עוד הזדמנות? 😊 מחזור התאמות זמין למנויים",
      );
      setShowSubscribeLink(true);
      setShowAlert(true);
      return;
    }

    if (answerText.length === 0) {
      alertUser("רק צריך להשאיר כמה מילים לצד השני ואפשר לנסות שוב 😊");
      return;
    }

    setIsSubmitting(true);
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      };
      await axios.post(
        process.env.REACT_APP_LOCALHOST_ADDRESS + `/prevMatches_proc`,
        {
          matchId,
          otherId,
          msgForOtherSide: answerText,
        },
        config,
      );
      await onMatchRenewal(matchId);
      const message = `שלחנו הודעה ל${otherName}, ההתאמה כעת מופיעה ב'התאמות חדשות' 😊 בהצלחה`;
      setAlertMessage(message);
      setShowAlert(true);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        alertUser("כבר חידשת את ההתאמה הזו השבוע 😊");
      } else {
        alertUser("לא הצלחנו למחזר את ההתאמה, נא לנסות שוב");
      }
    }
    setIsSubmitting(false);
  };

  const isQuotaExhausted = weeklyMatchesUsageLeft <= 0;

  return (
    <div className="response-container">
      <div className="faceline">
        <div>
          <div id="btnSubmit" style={{ fontSize: 16, fontWeight: "bold" }}>
            רוצה לנסות שוב?
          </div>

          {isQuotaExhausted ? (
            <span style={{ color: "var(--grey-color)" }}>
              ניצלת השבוע את כל המיחזורים האפשריים .
            </span>
          ) : (
            <>
              <div id="btnSubmit" style={{ fontSize: 14, margin: "6px 0" }}>
                אפשר לחדש השבוע עוד {weeklyMatchesUsageLeft} 'התאמות קודמות'.
                ההתאמה תעבור לבלוק <b>'התאמות חדשות'</b> לאחר השארת הודעה 😊
              </div>{" "}
            </>
          )}

          {/* הבהרה לאן ההתאמה עוברת ומה הסטטוס */}

          <div className="freetext-container">
            <textarea
              style={{ height: "40px" }}
              className="freetext"
              rows="3"
              maxLength="100"
              disabled={isQuotaExhausted}
              placeholder={
                isQuotaExhausted
                  ? "ניתן יהיה למחזר שוב בשבוע הבא..."
                  : `מה בא לך לכתוב ל${otherName}?`
              }
              value={answerText}
              onChange={(e) => setAnswerText(e.target.value)}
            />
          </div>

          <div
            id="btnSubmit"
            onClick={async () => {
              if (!isSubmitting) {
                await renewMatch();
              }
            }}
            style={{
              backgroundColor:
                answerText.length > 0
                  ? "var(--btn-color)"
                  : "var(--grey-color)",
              margin: "14px auto 0",
              padding: 8,
              borderWidth: 0,
              textAlign: "center",
              fontSize: 18,
              borderRadius: 10,
              fontFamily: "Heebo-VariableFon",
              color: "var(--btnText-color)",
              cursor: isSubmitting ? "default" : "pointer",
              opacity: isSubmitting ? 0.6 : 1,
              pointerEvents: isSubmitting ? "none" : "auto",
              userSelect: isSubmitting ? "none" : "auto",
            }}
          >
            {isSubmitting ? "שולח..." : "שליחה והעברה להתאמות השבוע"}
          </div>

          {showAlert && (
            <div className="error-message">
              <h5>{alertMessage}</h5>

              {showSubscribeLink && (
                <div className="lbl_grey">
                  <Link to="/Subscribe">לרכישת מנוי</Link> במחיר של כוס קפה
                  חודשית
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviousMatchResponseBlock;
